<div class="container"><img class="logo-shi" src="../../../../assets/images/smallshi.png" alt="..."></div>
<div class="container-nav">
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <div class="col-2" style="padding-right: 0px !important; padding-left: 0px !important;">
            <div class="icon-tienda">
                <img *ngIf="loading" class="animated fadeIn fast" src="../../../../assets/images/load_1.gif" alt="">
                <img *ngIf="!loading && nuevasTiendas['imagen'] == null" class="animated fadeIn fast" src="../../../../assets/images/broken-1.png" alt="...">
                <img *ngIf="!loading && nuevasTiendas['imagen'] != null" class="animated fadeIn fast" [src]="nuevasTiendas['imagen']" alt="...">
            </div>
        </div>
        <div class="col-8 p-1" >
            <div *ngIf="!loading">
                <b>{{ nuevasTiendas['nombre'] }}</b>
                <!-- <font size="2" style="font-family:'Montserrat-Regular';"><small>{{ nuevasTiendas.descripcion }}</small></font> -->

            </div>
        </div>
        <div class="card-tex col-2">
            <img style="width: 34px; height:34px;" src="../../../../assets/images/wsp.svg" alt="...">
        </div>

    </nav>
</div>
